import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getIndustrial, updateIndustrial } from "../../api/industrial";
import { getIntialValues, generatePayload } from "./helper";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();

  const getIndustrialQuery = useQuery({
    queryKey: ["industrial"],
    queryFn: getIndustrial,
  });

  const updateIndustrialMutation = useMutation({
    mutationFn: updateIndustrial,
    onSuccess: () => {
      toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
      getIndustrialQuery.refetch();
    },
    onError: () => {
      toaster.error(Const.MESSAGES.FAILED, "Error updating Industrial page.");
    },
  });

  const initialValues = useMemo(() => {
    const industrialData = getIndustrialQuery?.data?.data || {};
    return getIntialValues(industrialData);
  }, [getIndustrialQuery?.data]);

  const handleSubmit = (values) => {
    const payload = generatePayload(values);
    updateIndustrialMutation.mutate(payload);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        updateIndustrialQuery: updateIndustrialMutation,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageProvider = () => {
  return useContext(PageContext);
};
